<template>
  <div class="product">
    <div class="product-header">
      <div class="product-img">
        <el-image
          style="width: 200px; height: 200px"
          :src="product.image"
          fit="cover">
        </el-image>
      </div>
      <div class="product-title">
        <p style="padding: 5px;">{{ product.title }}</p>
        <p style="padding: 5px; font-size: 20px; color: red;">{{ productPrice }}</p>
      </div>
    </div>
    <div class="product-specifications">
      <div class="specifications" v-for="specification in specifications" :key="specification.id">
        <div>
          {{ specification.specification_name }}：
          <template v-for="specificationValue in specification.specification_vales">
            <el-radio size="mini" v-model="selectedValues[specification.id]" :label="specificationValue.id" :disabled="!isAvailable(specification.id, specificationValue.id, specificationValue)" border @change="selectRadio(specificationValue)">{{ specificationValue.specification_value }}</el-radio>
          </template>
        </div>
      </div>
    </div>
    <div class="product-html">
      <div v-html="product.description"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductShowView',
  components: {
  },
  computed: {
    productPrice () {
      return this.skuPrice ? this.skuPrice : this.product.price
    }
  },
  data () {
    return {
      product: {},
      specifications: [],
      selectedValues: {},
      validValues: [],
      skuPrice: null
    }
  },
  methods: {
    getProduct () {
      this.$axios.get('/api/admin/qyh_products/' + this.$route.params.id, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.product = data.data.product
            this.specifications = data.data.specifications
          }
        })
    },
    getValidSkusSku (vId) {
      this.$axios.post('/api/admin/qyh_product/sku', { values: this.selectedValues, skus: this.product.skus }, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.validValues = data.data.specValIds
            this.skuPrice = data.data.price
            for (let key in this.selectedValues) {
              if (!this.validValues.includes(this.selectedValues[key])) {
                this.$delete(this.selectedValues, key)
              }
            }
          }
        })
    },
    selectRadio (specificationValue) {
      // this.isAvailable(specificationValue.specification_id)
      this.getValidSkusSku(specificationValue.id)
    },
    isAvailable (specificationId, valueId, specificationValue) {
      if (this.validValues.length === 0) return true
      return this.validValues.includes(valueId)
    }
  },
  mounted() {
    this.getProduct()
  }
}
</script>

<style lang="stylus" scoped>
.product-header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
}
.product-img {
  text-align: right;
  flex: 1;
}
.product-title {
  flex: 1;
}
.specifications,.product-html {
  padding: 20px;
}
.specification-name {
  margin-bottom: 10px;
}
.product-specifications {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/all_products/common/ProductShowView.vue